// extracted by mini-css-extract-plugin
export default {"timeline":"Timeline-index__timeline--Zniaa"};